ScoreTrekBattle.League = ScoreTrekBattle.League || {};
ScoreTrekBattle.League.Matchday = ScoreTrekBattle.League.Matchday || {};

ScoreTrekBattle.League.Matchday.Roster = (function() {
    var _this;

    function getRole(player) {
        return player.role || player.squadRole || '';
    }

    function getLeaguePlayerId(player) {
        if (player.hasOwnProperty('leaguePlayerId')) {
            return player.leaguePlayerId || '';
        }

        return player.id || '';
    }

    function renderPlayer(player, options) {
        options = options || {};

        return ScoreTrekBattle.Template.render('league/matchday/lineupItem', {
            player: {
                id: player.id || '',
                playerId: player.playerId || '',
                fullName: player.fullName || '',
                role: getRole(player)
            }
        }, true).then(view => {
            decoratePlayer(view.$view, player);

            if (!options.canRemove) {
                view.$view.find('[data-id="controls"]').remove();
            }

            return view.$view;
        });
    }

    function decoratePlayer($item, player) {
        let app;

        app = player.player || {};

        if (app.thumbnail) {
            $item.find('[data-id="avatar"]').css('background-image', `url('${app.thumbnail}')`);
        }

        $item.toggleClass('isProPlayer', !!app.pro_account);

        $item.find('[data-id="roleName"]').text(__i18n(`squad/role/${getRole(player) || 'substitute'}`));

        if (player.playerId) {
            return;
        }

        $item.attr('title', __i18n('player/custom'));
        $item.find('[data-id="originBadge"]').html('<span class="badge bg-color-white color-pink ml-small" data-info-popup="squad/player/manualInfo"><i class="fa-solid fa-user-slash"></i></span>');
    }

    function renderOption(option) {
        return ScoreTrekBattle.Template.render('league/matchday/lineup/editorOption', {
            option: {
                type: option.type || ''
            }
        }, true).then(view => {
            view.$view.find('[data-id="icon"]').html(option.icon || '');
            view.$view.find('[data-id="label"]').text(option.label || '');

            if (option.note) {
                view.$view.find('[data-id="note"]').text(option.note).css('display', '');
            }

            return view.$view;
        });
    }

    function addPlayer(matchdayId, side, options) {
        let dialog, isPrepared, isOwnSide;

        options = options || {};
        isPrepared = false;
        isOwnSide = (side === 'own');

        function getPlayers() {
            return options.getPlayers ? (options.getPlayers() || []) : [];
        }

        function isPlayerAdded(playerId) {
            if (!playerId) {
                return false;
            }

            return getPlayers().some(player => {
                return ((player.playerId || '') === playerId);
            });
        }

        function isLeaguePlayerAdded(leaguePlayerId) {
            if (!leaguePlayerId) {
                return false;
            }

            return getPlayers().some(player => {
                return (getLeaguePlayerId(player) === leaguePlayerId);
            });
        }

        function prepare() {
            if (isPrepared || !options.prepare) {
                isPrepared = true;
                return Promise.resolve();
            }

            return Promise.resolve(options.prepare()).then(() => {
                isPrepared = true;
            });
        }

        function create(data) {
            return prepare().then(() => {
                return Api.request('/battle/league/matchday/lineup/player/add', {
                    id: matchdayId,
                    side: side,
                    player: data
                });
            }).then(result => {
                ScoreTrekBattle.Event.callFunction(
                    options.onAdded,
                    (result && result.player) ? result.player : null,
                    (result && result.players) ? result.players : {}
                );

                if (options.closeAfterAdd && dialog) {
                    dialog.close();
                }

                return true;
            }).catch(error => {
                chmDialog.error(error);

                return false;
            });
        }

        dialog = ScoreTrekBattle.PlayerSearch.open({
            title: __i18n('matchday/player/dialog/title'),
            placeholder: __i18n('matchday/player/search'),
            allowOtherClubs: isOwnSide,
            createLabel: function(name) {
                return __i18n('matchday/player/createNamed', {name: name}, true);
            },
            pool: isOwnSide ? ScoreTrekBattle.PlayerSearch.clubPool({
                isAdded: function(leaguePlayer) {
                    return isLeaguePlayerAdded(leaguePlayer.id);
                },
                onSelect: function(leaguePlayer) {
                    return create({leaguePlayerId: leaguePlayer.id, fullName: leaguePlayer.fullName || ''});
                }
            }) : null,
            isAdded: function(playerId) {
                return isPlayerAdded(playerId);
            },
            onSelect: function(player) {
                return create({playerId: player.id, fullName: player.name});
            },
            onCreate: function(name) {
                return create({fullName: name});
            }
        });

        return dialog;
    }

    _this = {
        getRole: getRole,
        renderPlayer: renderPlayer,
        renderOption: renderOption,
        addPlayer: addPlayer
    };

    return _this;
})();
